export default (node) => {
  /**
   * Data + elements
   */
  const track = node.querySelector('[data-carousel-track]');
  const slides = node.querySelectorAll('[data-slide]');
  const prevButtons = node.querySelectorAll('[data-action="prev"]');
  const nextButtons = node.querySelectorAll('[data-action="next"]');
  const totalSlides = slides.length;
  let currentSlide = 1;

  /**
   * Functions
   */
  const updateTrackHeight = (activeSlide) => {
    if (track && activeSlide) {
      track.style.height = `${activeSlide.scrollHeight}px`;
    }
  };

  const goToSlide = (slide) => {
    slides.forEach((s) => s.classList.remove('active'));
    const activeSlide = node.querySelector(`[data-slide="${slide}"]`);
    if (activeSlide) {
      activeSlide.classList.add('active');
      updateTrackHeight(activeSlide);
    }
  };

  const navigate = (direction) => {
    if (direction === 'next') {
      currentSlide = currentSlide >= totalSlides ? 1 : currentSlide + 1;
    } else {
      currentSlide = currentSlide <= 1 ? totalSlides : currentSlide - 1;
    }
    goToSlide(currentSlide);
  };

  /**
   * Init
   */
  const init = () => {
    if (!totalSlides) return;
    prevButtons.forEach((button) =>
      button.addEventListener('click', () => navigate('prev'))
    );
    nextButtons.forEach((button) =>
      button.addEventListener('click', () => navigate('next'))
    );
    updateTrackHeight(node.querySelector('[data-slide].active') || slides[0]);
    window.addEventListener('resize', () => {
      const activeSlide = node.querySelector('[data-slide].active');
      updateTrackHeight(activeSlide);
    });
  };

  init();
};
